import React from "react";
import { motion } from "framer-motion";

export default function SectionTitle({ eyebrow, title, subtitle, align = "left", testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
      data-testid={testId}
    >
      {eyebrow && <div className="overline mb-4">{eyebrow}</div>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light text-[var(--ink)] leading-[1.05]">
        {title}
      </h2>
      {subtitle && <p className="mt-5 text-[15px] sm:text-base text-[var(--text-secondary)] font-body leading-relaxed">{subtitle}</p>}
    </motion.div>
  );
}
